export function isMainDomain(domain) {
  return domain?.isMainCategory !== false && !`${domain?.parentDomainId || ""}`.trim();
}

export function getMainDomainId(domainId, domainById) {
  const d = domainById?.[domainId];
  if (!d) return "";
  const parentId = `${d.parentDomainId || ""}`.trim();
  return parentId || d.id || "";
}

export function getDomainCity(domain) {
  return `${domain?.city || ""}`.trim();
}

export function getDomainPathParts(domain, domainById) {
  if (!domain) return { main: "", sub: "", city: "" };
  const parentId = `${domain.parentDomainId || ""}`.trim();
  const parent = parentId ? domainById?.[parentId] : null;
  return {
    main: parent ? (parent.name || "") : (domain.name || ""),
    sub: parent ? (domain.name || "") : "",
    city: "",
  };
}

export function getDomainPathLabel(domain, domainById, { includeCity = true } = {}) {
  if (!domain) return "";
  const { main, sub } = getDomainPathParts(domain, domainById);
  if (!sub) return main || domain.name || "";
  return `${main} / ${sub}`;
}

export function groupSubdomainsByName(children = []) {
  const groups = {};
  children.forEach((child) => {
    const name = `${child?.name || ""}`.trim() || "ללא שם";
    const key = name.toLowerCase();
    if (!groups[key]) groups[key] = { key, name, items: [] };
    groups[key].items.push(child);
  });
  return Object.values(groups).sort((a, b) => a.name.localeCompare(b.name, "he"));
}

export function uniqueSubdomainNames(children = []) {
  const seen = new Set();
  const rows = [];
  children.forEach((d) => {
    const name = `${d?.name || ""}`.trim();
    if (!name) return;
    const key = name.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    rows.push(name);
  });
  return rows.sort((a, b) => a.localeCompare(b, "he"));
}
